import { borderRadius as o } from "./borderRadius.es.js";
import { colors as r } from "./colors.es.js";
import { shadow as m } from "./shadow.es.js";
const t = {
  name: "Main",
  borderRadius: o,
  colors: r,
  shadow: m,
  variables: {}
};
export {
  t as main
};
//# sourceMappingURL=index.es.js.map
